


























































































import {
    Component, Vue, Prop, Mixins,
} from 'vue-property-decorator';
import product, { ProductUIInfo, ProductUIInfoFuse } from '@/store/modules/product';
import { ActivityInfo } from '@luxtag/papybase';
import theme from '@/config/config-ui';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';

@Component
export default class ProductListHeader extends Mixins(IsMobileMixin) {
    @Prop(Object) public product!: ProductUIInfo;

    public statusColorClass = {

    };

    public created() {
        // console.log(this.product.status);
        if (this.product.status) {
            this.$set(this.statusColorClass, this.product.status, true);
        }
    }

    public onClickDelete() {
        this.$emit('click:delete', this.product.id);
    }

    get productActivities(): ActivityInfo[] {
        return this.$store.getters.getProductActivities(this.product.address);
    }

    get miniCircleColor() {
        if (this.productActivities.length > 0) {
            const firstProductActivity = this.productActivities[0];
            if (firstProductActivity.action === 'CLAIM') {
                // return 'success';
                return theme.success;
            } if (firstProductActivity.action === 'TRANSFER') {
                // return 'warning';
                return theme.warning;
            }
        }
        // return 'brownGrey';
        return theme.brownGrey;
    }

    get miniCircleTooltip() {
        if (this.productActivities.length > 0) {
            const firstProductActivity = this.productActivities[0];
            if (firstProductActivity.action === 'CLAIM') {
                return 'Claimed';
            } if (firstProductActivity.action === 'TRANSFER') {
                return 'Transferred';
            }
        }
        return 'Unclaimed';
    }
}
